// extracted by mini-css-extract-plugin
module.exports = {"bottomLine":"IconItems_bottomLine__1Bl6X","items":"IconItems_items__1OeHE","item":"IconItems_item__1OAZu","icon":"IconItems_icon__2D5BC","right":"IconItems_right__KTJjC"};